// Contentful default is 30 seconds which is too long for our use case
// Their CDN responds sub-second so we can afford to be more aggressive
export const DEFAULT_CLIENT_TIMEOUT = 10000;
